import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShipmentStatus } from '@graphql-types';

interface StatusMetadata {
  name: string;
  className: string;
  icon: string;
}

@Component({
  selector: 'nx-shipment-status',
  imports: [MatIconModule],
  templateUrl: './shipment-status.component.html',
  styleUrl: './shipment-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentStatusComponent {
  status = input.required<ShipmentStatus>();

  currentStatus = computed(
    () => this.statusMap[this.status()] ?? this.statusMap.unknown
  );

  readonly statusMap: Record<ShipmentStatus | 'unknown', StatusMetadata> = {
    unknown: {
      name: 'Unknown',
      className: 'unknown',
      icon: 'ic-unknown-currentColor',
    },
    [ShipmentStatus.Open]: {
      name: 'Open',
      className: 'fields',
      icon: 'ic-pending-s',
    },
    [ShipmentStatus.Quoted]: {
      name: 'Quoted',
      className: 'sky-blue',
      icon: 'ic-pending-s',
    },
    [ShipmentStatus.Reserved]: {
      name: 'Reserved',
      className: 'violet',
      icon: 'ic-lock-currentColor',
    },
    [ShipmentStatus.Covered]: {
      name: 'Covered',
      className: 'mint',
      icon: 'ic-accepted-s',
    },
    [ShipmentStatus.Dispatched]: {
      name: 'Dispatched',
      className: 'link',
      icon: 'ic-dispatched-currentColor',
    },
    [ShipmentStatus.AtPickup]: {
      name: 'At pick-up',
      className: 'orange',
      icon: 'ic-at-pick-up',
    },
    [ShipmentStatus.Loaded]: {
      name: 'Loaded',
      className: 'link',
      icon: 'ic-loaded-currentColor',
    },
    [ShipmentStatus.InTransit]: {
      name: 'In transit',
      className: 'link',
      icon: 'ic-dispatched-currentColor',
    },
    [ShipmentStatus.InTransitGatedIn]: {
      name: 'In transit (gated in)',
      className: 'link',
      icon: 'ic-dispatched-currentColor',
    },
    [ShipmentStatus.OnSite]: {
      name: 'On-site',
      className: 'orange',
      icon: 'ic-truck',
    },
    [ShipmentStatus.AtConsignee]: {
      name: 'At consignee',
      className: 'orange',
      icon: 'ic-at-drop-off',
    },
    [ShipmentStatus.GatedIn]: {
      name: 'Gated in',
      className: 'purple',
      icon: 'ic-truck',
    },
    [ShipmentStatus.GatedOut]: {
      name: 'Gated out',
      className: 'purple',
      icon: 'ic-truck',
    },
    [ShipmentStatus.Dropped]: {
      name: 'Dropped',
      className: 'fields',
      icon: 'ic-at-drop-off',
    },
    [ShipmentStatus.Delivered]: {
      name: 'Delivered',
      className: 'green',
      icon: 'ic-completed-s-currentColor',
    },
    [ShipmentStatus.Released]: {
      name: 'Released',
      className: 'green',
      icon: 'ic-released',
    },
    [ShipmentStatus.Claim]: {
      name: 'Claim',
      className: 'red',
      icon: 'ic-file-claim',
    },
    [ShipmentStatus.TruckOrderNotUsed]: {
      name: 'Truck order not used',
      className: 'red',
      icon: 'ic-not-used-currentColor',
    },
  };
}
